import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../Partial/Header';
import Footer from '../Partial/Footer';
import Prdt1 from '../Assets/images/product-2.png';
import Prdt2 from '../Assets/images/product-1.png';
import Prdt3 from '../Assets/images/third-prod-1.png';
import Prdt4 from '../Assets/images/third-prod-2.png';
import Prdt5 from '../Assets/images/third-prod-3.png';
import Prdt6 from '../Assets/images/third-prod-4.png';
import Prdt7 from '../Assets/images/forth-prod-1.png';
import { BASE_URL } from '../config';
import { Link } from 'react-router-dom';
import LoaderOverlay from '../Partial/LoaderOverlay';




const ProductView = () => {

    let [firstData, setFirstData] = useState([]);
    let [secondData, setSecondData] = useState([]);
    //const [searchText, setSearchText] = useState('');
    const [showModal, setShowModal] = useState(false);
    //const [searchResults, setSearchResults] = useState("");
    const [loading, setLoading] = useState(true);



    let fetchData = async () => {
        try {
            setLoading(true);
            await axios.get(`${BASE_URL}/get-homepage`)
                .then(res => {
                    if (res.data.responseCode === 200) {
                        console.log("res.data.responseData.first>>", res.data.responseData.first, "res.data.responseData.second>>>", res.data.responseData.second);
                        setFirstData(res.data.responseData.first);
                        setSecondData(res.data.responseData.second);

                    }
                })
        } catch (error) {
            console.log(error);

        } finally {
            setLoading(false);
        }
    }


    useEffect(() => {
        fetchData();

    }, []);

    return (
        <>
            {loading && <LoaderOverlay />}
            <Header />
            <section className="searchcontainer">
                <span className="seachpattern">
                    <svg width="525" height="454" viewBox="0 0 525 454" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M524.996 -2.76343H-356.388M524.996 59.5334H-356.388M524.996 121.83H-356.388M524.996 184.127H-356.388M524.996 246.424H-356.388M524.996 308.721H-356.388M524.996 371.018H-356.388M524.996 433.315H-356.388M473.582 453.426L473.582 -6.8772M399.749 453.426L399.749 -6.8772M325.916 453.426L325.916 -6.8772M252.083 453.426L252.082 -6.8772M178.25 453.426L178.249 -6.8772M104.417 453.426L104.417 -6.8772M30.584 453.426L30.584 -6.8772M-43.249 453.426V-6.8772M-117.082 453.426V-6.8772M-190.915 453.426V-6.8772M-264.748 453.426V-6.8772M-338.581 453.426V-6.8772" stroke="url(#paint0_linear_87_29)" strokeOpacity="0.08" />
                        <defs>
                            <linearGradient id="paint0_linear_87_29" x1="-223.192" y1="337.222" x2="217.544" y2="163.201" gradientUnits="userSpaceOnUse">
                                <stop stopColor="white" stopOpacity="0" />
                                <stop offset="0.5" stopColor="white" />
                                <stop offset="1" stopColor="white" stopOpacity="0" />
                            </linearGradient>
                        </defs>
                    </svg>
                </span>
                <span className="seachpattern seachpatternrt">
                    <svg width="525" height="454" viewBox="0 0 525 454" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M524.996 -2.76343H-356.388M524.996 59.5334H-356.388M524.996 121.83H-356.388M524.996 184.127H-356.388M524.996 246.424H-356.388M524.996 308.721H-356.388M524.996 371.018H-356.388M524.996 433.315H-356.388M473.582 453.426L473.582 -6.8772M399.749 453.426L399.749 -6.8772M325.916 453.426L325.916 -6.8772M252.083 453.426L252.082 -6.8772M178.25 453.426L178.249 -6.8772M104.417 453.426L104.417 -6.8772M30.584 453.426L30.584 -6.8772M-43.249 453.426V-6.8772M-117.082 453.426V-6.8772M-190.915 453.426V-6.8772M-264.748 453.426V-6.8772M-338.581 453.426V-6.8772" stroke="url(#paint0_linear_87_29)" strokeOpacity="0.08" />
                        <defs>
                            <linearGradient id="paint0_linear_87_29" x1="-223.192" y1="337.222" x2="217.544" y2="163.201" gradientUnits="userSpaceOnUse">
                                <stop stopColor="white" stopOpacity="0" />
                                <stop offset="0.5" stopColor="white" />
                                <stop offset="1" stopColor="white" stopOpacity="0" />
                            </linearGradient>
                        </defs>
                    </svg>
                </span>
                <div className="container">

                </div>
            </section>

            <section className="producthomecontainer">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="section-heading text-start">
                                <h2>Our <span>Products</span></h2>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 mb-4 mb-lg-0">
                            <div className="prohomebx firstproduct">
                                <div className="productinner">
                                    {firstData.map((item, index) => (
                                        <span
                                            key={item.id}
                                            className={`productpointer pro-one box-${index + 1}`}
                                        >
                                            <span className="productbxct">
                                                {/* <Link to={`/contact-us/1/${item.model_name}`} className="productbxcttitle">
                                                    {item.model_name}
                                                </Link> */}
                                                {item.count === 1 ? (
                                                    <Link to={`/product-details/${btoa(item.id)}`} className="productbxcttitle">
                                                        {item.model_name}
                                                    </Link>
                                                ) : (
                                                    <Link to={`/contact-us/1/${item.model_name}`} className="productbxcttitle">
                                                        {item.model_name}
                                                    </Link>
                                                )}
                                            </span>
                                        </span>
                                    ))}
                                    <img src={Prdt1} alt="" />
                                </div>
                            </div>
                        </div>

                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 mb-4 mb-lg-0">
                            <div className="prohomebx secoundproduct">
                                <div className="productinner">
                                    {secondData.map((item, index) => (
                                        <span
                                            key={item.id}
                                            className={`productpointer pro-two box-${index + 1}`} // dynamic box-1, box-2, etc.
                                        >
                                            <span className="productbxct">
                                                {/* <Link to={`/product-details/${btoa(item.id)}`} className="productbxcttitle">
                                                    {item.model_name}
                                                </Link> */}
                                                {item.count === 1 ? (
                                                    <Link to={`/product-details/${btoa(item.id)}`} className="productbxcttitle">
                                                        {item.model_name}
                                                    </Link>
                                                ) : (
                                                    <Link to={`/contact-us/1/${item.model_name}`} className="productbxcttitle">
                                                        {item.model_name}
                                                    </Link>
                                                )}
                                            </span>
                                        </span>
                                    ))}

                                    <img src={Prdt2} alt="" />
                                </div>
                            </div>
                        </div>

                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 mb-4 mb-lg-0">
                            <div className="prohomebx thirdproduct">
                                <div className="row">
                                    <div className="col-xx-6 col-xx-4 col-lg-6 col-md-6 col-sm-6 col-6">
                                        <div className="productinner">
                                            <span className="productpointer pro-three box-1">
                                                <span className="productbxct">
                                                    <Link to="/contact-us/1/AK" className="productbxcttitle">
                                                        AK
                                                    </Link>

                                                </span>
                                            </span>
                                            <img src={Prdt3} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-xx-6 col-xx-4 col-lg-6 col-md-6 col-sm-6 col-6">
                                        <div className="productinner">
                                            <span className="productpointer pro-three box-1">
                                                <span className="productbxct">
                                                    <Link to="/contact-us/1/AT" className="productbxcttitle">
                                                        AT
                                                    </Link>

                                                </span>
                                            </span>
                                            <img src={Prdt4} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-xx-6 col-xx-4 col-lg-6 col-md-6 col-sm-6 col-6">
                                        <div className="productinner">
                                            <span className="productpointer pro-three box-2">
                                                <span className="productbxct">
                                                    <Link to="/contact-us/1/HK" className="productbxcttitle">
                                                        HK
                                                    </Link>

                                                </span>
                                            </span>
                                            <img src={Prdt5} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-xx-6 col-xx-4 col-lg-6 col-md-6 col-sm-6 col-6">
                                        <div className="productinner">
                                            <span className="productpointer pro-three box-2">
                                                <span className="productbxct">
                                                    <Link to="/contact-us/1/HT" className="productbxcttitle">
                                                        HT
                                                    </Link>

                                                </span>
                                            </span>
                                            <img src={Prdt6} alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 mb-4 mb-lg-0">
                            <div className="prohomebx forthproduct">
                                <div className="productinner">
                                    <span className="productpointer pro-forth first">
                                        <span className="productbxct">
                                            <Link to="/contact-us/1/F2B" className="productbxcttitle">
                                                F2B
                                            </Link>
                                        </span>
                                    </span>
                                    <img src={Prdt7} alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default ProductView;